import React from 'react';
import { LiabilityStatus } from '../types/credit';
const styles: Record<LiabilityStatus, string> = {
  Open: 'bg-green-50 text-green-800 ring-green-200',
  Closed: 'bg-ink-50 text-ink-700 ring-ink-300',
  Collection: 'bg-red-50 text-red-800 ring-red-200'
};
export function StatusBadge({
  status
}: {
  status: LiabilityStatus;
}) {
  return <span className={`inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${styles[status]}`} data-id="element-104" data-mp="3fgkeqsqnabat">
      {status}
    </span>;
}